import './style.scss'
import Torres from '../../Assets/torres.jpg'
import { Bounce } from 'react-reveal'

export default function Second(){
    return(
        <div className="second-page" id="mintic">
            <Bounce bottom cascade>
            <div className='text'>
                <div>
                    <h1>ASESORÍA ESPECIALIZADA EN PROCESOS MINTIC</h1>
                </div>
                <div>
                    <p>
                        En Conexión Estratégica, ofrecemos una amplia gama de servicios de consultoría especializados en trámites con el MINTIC. Desde la adjudicación de frecuencias hasta la renovación de permisos de uso del espectro, nuestro equipo experto está aquí para ayudarte en cada paso del proceso. Con más de 40 años de experiencia, garantizamos un proceso fluido y sin problemas para nuestros clientes.
                    </p>
                </div>
                <div className='div-image'>
                    <img src={Torres} alt='Logo'/>
                </div>
            </div>
            </Bounce>
        </div>
    )
}